import { createContext, useContext } from 'react';

const ThemeModeContext = createContext({ themeMode: 'light', setThemeMode: () => {} });

export const ThemeModeProvider = ThemeModeContext.Provider;

export const useThemeModeContext = () => useContext(ThemeModeContext);
